import { render, staticRenderFns } from "./ModalEditApproveContract.vue?vue&type=template&id=6d338c5a&scoped=true&"
import script from "./ModalEditApproveContract.vue?vue&type=script&lang=ts&"
export * from "./ModalEditApproveContract.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditApproveContract.vue?vue&type=style&index=0&id=6d338c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d338c5a",
  null
  
)

export default component.exports